const Loading = (props: {
  className?: string,
  style?: React.CSSProperties,
}) => {
  return <img src='images/loading.gif' alt='Loading...' className={props.className} style={props.style} data-testid="loading-image" />;
};

export default Loading;
